import React, {Component} from 'react';
import { Card} from 'react-bootstrap';
import MenuCategory from '../../Elements/MenuCategory';


class MenuCard extends Component {  
        
    render(){ 
        if (!this.props.categories) {
            return <div>loading</div>
        }

        let name = JSON.parse(this.props.name);
        let lang = this.props.lang.toUpperCase();
        
        return (
            <div className="container-fluid content " id="card-wrapper" >
                <Card style={{ width: '100%' }}>
                    <Card.Body className="menu__name">
                        <Card.Title className="text-capitalize text-center" style={{fontSize: "2rem"}}>{name[lang]}</Card.Title>
                    </Card.Body>
                    { 
                     this.props.categories.map((cat, i) =>{
                        return (
                            <MenuCategory key={i} categorie={cat} lang={lang}/>
                        )
                    })}
                </Card>
            </div>
            );
    }
}

export default MenuCard;